import MuiTableBody from "@mui/material/TableBody";
import { Identifiable, TableBodyProps } from "../../../types";
import TableRow from "./TableRow";

const TableBody = <T extends Identifiable, CollapsingRowName extends string | undefined = undefined>({
  data,
  collapsingRowName,
  checkIsCollapsingRow,
  onRowClick,
}: TableBodyProps<T, CollapsingRowName>) => {
  return (
    <MuiTableBody>
      {data.map((row) => (
        <TableRow<T, CollapsingRowName>
          checkIsCollapsingRow={checkIsCollapsingRow}
          collapsingRowName={collapsingRowName}
          row={row}
          key={`row-${row.id}`}
          onRowClick={onRowClick}
        />
      ))}
    </MuiTableBody>
  );
};

export default TableBody;
